import { render, staticRenderFns } from "./GameActions.vue?vue&type=template&id=34be6438"
import script from "./GameActions.vue?vue&type=script&lang=js"
export * from "./GameActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports